import { Card, Collapse } from 'antd'
import Button from 'components/Button'
import Spinner from 'components/Spinner'
import useReadingAssessmentResponse, { IReadingAssessmentResponse } from 'components/useReadingAssessmentResponse'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { LeftOutlined } from '@ant-design/icons';
import ResponseModal from './ReadingResponseModal'


type Params = {
    readingAssessmentResponse: IReadingAssessmentResponse
}

export default function ReadingAssessmentResponse({ readingAssessmentResponse }: Params) {
    const [showResponseModal, setShowResponseModal] = useState(false)

    return (
        <div className='mb-2'>
            {/* <h5 className='is-size-5 mb-3'>
                <strong>{readingAssessmentResponse.reading_assessment.title}</strong>
            </h5> */}
            <Card bordered>
                <div className="columns">
                    <div className="column">
                        <div className="between">
                            <strong>
                                Reading
                            </strong>
                            <Button
                                onClick={() => setShowResponseModal(true)}
                                style={{ fontSize: "10px" }}
                                variant='is-light'>View Response</Button>
                        </div>

                        <table className='table w-100'>
                            <tbody>
                                <tr>
                                    <td>Speed</td>
                                    <td>{readingAssessmentResponse.words_per_minute}</td>
                                </tr>
                                <tr>
                                    <td>Accuracy</td>
                                    <td>{readingAssessmentResponse.accuracy}</td>
                                </tr>
                                <tr>
                                    <td>Comprehension</td>
                                    <td>{readingAssessmentResponse.comprehension}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="column">
                        <div className="between">
                            <strong>
                                Quizzes
                            </strong>
                        </div>
                        <table className='table w-100'>
                            <tbody>
                                <tr>
                                    <td>Topic</td>
                                    <td>{readingAssessmentResponse.quiz_session?.topic}</td>
                                </tr>
                                <tr>
                                    <td>Score Percentage</td>
                                    <td>{readingAssessmentResponse.quiz_session?.score_percentage || 0} %</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </Card>
            {showResponseModal && <ResponseModal
                readingAssessmentResponse={readingAssessmentResponse}
                onClose={() => setShowResponseModal(false)}
            />}
        </div>
    )
}


export function ReadingAssessmentResponses({ readingAssessmentResponses }: { readingAssessmentResponses: IReadingAssessmentResponse[] }) {
    const [items, setItems] = useState({})
    useEffect(() => {
        let lookup = {}
        for (let i = 0; i < readingAssessmentResponses.length; i++) {
            const rar = readingAssessmentResponses[i];
            lookup[rar.user.id] = lookup[rar.user.id] || []
            lookup[rar.user.id].push(rar)
        }
        setItems(lookup)
    }, [readingAssessmentResponses])

    return <div className='reading-assessment-responses'>
        {Object.entries(items).map(([user_id, rars]) => {
            //@ts-ignore
            let item: IReadingAssessmentResponse = rars[0]
            return <div key={user_id}>
                <Collapse
                    defaultActiveKey={['1']}
                    ghost
                    items={[
                        {
                            key: "1",
                            label: <div>
                                <h5 className='is-size-5'>
                                    <strong>
                                        {item.user.firstName} {item.user.lastName}
                                    </strong>
                                </h5>
                                <small>{item.user.username}</small>
                            </div>,
                            children: (rars as []).map((rar: IReadingAssessmentResponse) => {
                                if (rar.accuracy === 0 && rar.words_per_minute === 0 && rar.comprehension === 0) {
                                    return null
                                }
                                return <ReadingAssessmentResponse
                                    key={rar.id}
                                    readingAssessmentResponse={rar}
                                />
                            })
                        }
                    ]} />

            </div>
        })}

    </div>
}

export function ReadingAssessmentResponsesPage() {
    let { assessment_id } = useParams();
    const navigate = useNavigate();

    const {
        isLoading,
        mutateAsync: fetchReadingAssessmentResponses
    } = useReadingAssessmentResponse()

    const [readingAssessmentResponses, setReadingAssessmentResponses] = useState<IReadingAssessmentResponse[]>([])

    useEffect(() => {
        let query: any = { assessment_id }
        fetchReadingAssessmentResponses(query).then(v => {
            console.log(v)
            setReadingAssessmentResponses(v)
        })
    }, [assessment_id, fetchReadingAssessmentResponses])

    if (isLoading) {
        return <div className="center my-5">
            <Spinner />
        </div>
    }

    return <div
        className='px-5 py-5'
        style={{ maxHeight: "100vh", overflow: "auto" }}
    >
        <div className='mt-3'>
            <Button
                variant='is-light'
                className='py-1'
                onClick={() => navigate(-1)}
            >
                <LeftOutlined className='mr-2' />
                Back
            </Button>
        </div>

        {
            readingAssessmentResponses.length === 0
                ? <em className='center mt-3'>No responses recorded yet</em>
                : <>
                    <h3 className='is-size-3 mb-3 pl-6 py-3'>
                        <strong>{readingAssessmentResponses[0].reading_assessment.title}</strong>
                    </h3>
                    <ReadingAssessmentResponses
                        readingAssessmentResponses={readingAssessmentResponses}
                    />
                </>
        }

    </div>

}